import { HashRouter, Routes, Route } from 'react-router-dom';
import { AppShell } from '@/components/layout/app-shell';

export default function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="*" element={<AppShell />} />
      </Routes>
    </HashRouter>
  );
}
